export const contactsData = {
  email: "mjguptacse@gmail.com",
  phone: "+91-9135407413",
  address: "Jamshedpur Jharkhand India 831012 ",

  sheetAPI: "https://sheetdb.io/api/v1/0q0i70gypxuay",
};
